module.exports = __webpack_public_path__ + "static/liva-convert-detail-five-bd59e2e31cc4a8723377f8152b772d32.png";